var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:[_vm.compactMode ? 'ma-0 pa-2' : 'mt-1 mb-0 mx-0 pa-2'],style:({ height: _vm.cardHeight + 'px', overflowY: 'auto' })},[_c('v-layout',{attrs:{"column":""}},[(
        _vm.compactMode ||
          (!_vm.compactMode && !_vm.isPhasesDone && !_vm.isReleaseOrderActive) ||
          (!_vm.compactMode && !_vm.isPhases && !_vm.isReleaseOrderActive) ||
          (!_vm.compactMode && !_vm.isReleaseOrderActive && _vm.isPhaseActive)
      )?_c('ShippingPhases',{attrs:{"can-edit":_vm.canEdit,"user":_vm.user}}):_vm._e(),(_vm.compactMode)?_c('v-divider',{staticClass:"my-4",attrs:{"horizontal":""}}):_vm._e(),(
        _vm.compactMode ||
          (!_vm.compactMode && _vm.isPhasesDone && !_vm.isPhaseActive) ||
          (!_vm.compactMode && _vm.isReleaseOrderActive && !_vm.isPhaseActive)
      )?_c('ShippingReleaseOrders',{attrs:{"can-edit":_vm.canEdit,"shipping-id":_vm.id}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }